import { RpcService } from '@holmescorp/rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@lrs.rpc`,
    services: {
        get_statement: {
            parameters: [
                { name: 'statementid', type: 'number', optional: true },
                { name: 'statementId', type: 'number', optional: true },
                { name: 'verb', type: 'string', optional: true },
                { name: 'activity', type: 'string', optional: true },
                { name: 'agent', type: 'string', optional: true },
                { name: 'since', type: 'Date', optional: true },
                { name: 'until', type: 'Date', optional: true },
                { name: 'ascending', type: 'boolean', optional: true },
                { name: 'limit', type: 'number', optional: true },
                { name: 'format', type: 'string', optional: true }
            ]
        },
        set_statement: {
            parameters: [
                {
                    name: 'stmnt',
                    type: 'object',
                    optional: false
                },
                {
                    name: 'site',
                    type: 'string',
                    optional: true
                }
            ]
        },
        set_actor: {
            parameters: [
                {
                    name: 'actr',
                    type: 'object',
                    optional: false
                },
                {
                    name: 'site',
                    type: 'string',
                    optional: true
                }
            ]
        }
    }
});
export default svc;
